import { setErrorLoggingEnabled } from './errorDebugLogStore';
import { setPerformanceLoggingEnabled } from './performanceDebugLogStore';

type SetDiagnosticsLoggingEnabled = (isEnabled: boolean) => void;
export const setDiagnosticsLoggingEnabled: SetDiagnosticsLoggingEnabled = (isEnabled) => {
  setErrorLoggingEnabled(isEnabled);
  setPerformanceLoggingEnabled(isEnabled);
};
